/**
 * Cloud Functions API handlers (domain module).
 */

import { httpsCallable } from 'firebase/functions'
import { functions } from '../../../libs/Firebase'
import { ApiResponse } from '../../types'
import { State } from '../../../hooks/useAppState'

import { TriggerReflectionEmailRequest } from '../../../../../pure-js/types/TriggerReflectionEmailRequest'
import { SendBookDemoEmailRequest } from '../../../../../pure-js/types/types'

export const triggerReflectionEmail = async (
  req: TriggerReflectionEmailRequest,
  _state: State
): Promise<ApiResponse<unknown>> => {
  try {
    const callable = httpsCallable(functions, 'triggerReflectionEmail')
    const result = await callable(req)
    return { data: result.data, success: true }
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : 'Failed to trigger reflection email'
    return { data: null, success: false, error: message }
  }
}

export const sendBookDemoEmail = async (
  req: SendBookDemoEmailRequest,
  _state: State
): Promise<ApiResponse<{ success: boolean }>> => {
  try {
    const callable = httpsCallable(functions, 'sendBookDemoEmail')
    const result = await callable(req)
    return { data: result.data as { success: boolean }, success: true }
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : 'Failed to send demo request'
    return { data: { success: false }, success: false, error: message }
  }
}
